import React, {CSSProperties} from "react";
import "./tile.scss";
import {SimpleTimetableActionModel, TimetableActionTypes, TimetableActionTypesFirstLetter} from "../../models/timetable";
import {DateUtils} from "../../../helpers/dateUtils";
import i18n from "../../../i18n/i18n";
import {NavLink} from "react-router-dom";
import {routingAddresses} from "../../../helpers/routing";
import Button from "../../../common/components/shared/button/button";
import DetailsPopup from "../detailsPopup/detailsPopup";
import {ITimetableStore} from "../../stores/timetableStore";
import {storesContext} from "../../../common/stores/stores";

interface TileProps {
    data?: SimpleTimetableActionModel | string;
    type: "action" | "ferryName" | "wharfName" | "wharfLabel" | "notes" | "empty";
    testId: string;
    isLongTime?: boolean;
    style?: CSSProperties;
    canUpdate?: boolean;
    onClickButton?: () => void;
    isCanceled?: boolean;
}

interface TileState {
    openDetailsPopup: boolean;
}

export default class Tile extends React.Component <TileProps, TileState> {
    static contextType = storesContext;

    public constructor(props: TileProps) {
        super(props);

        this.state = {
            openDetailsPopup: false
        };
    }

    public render() {
        return (
            <div className={`tile ${this.props.type} ${this.props.isLongTime ? "long-time" : ""} ${this.props.isCanceled ? "canceled" : ""}`} data-testid={this.props.testId} id={this.props.testId}>
                <div className="tile-data" style={this.props.style}>
                    {this.renderData()}
                </div>
            </div>
        );
    }

    private renderData() {
        switch (this.props.type) {
            case "ferryName":
            case "wharfName":
            case "wharfLabel":
            case "notes":
                return typeof this.props.data === "string" ? this.renderName(this.props.data as string) : null;
            case "action":
                return typeof this.props.data != "string" ? this.renderAction(this.props.data as SimpleTimetableActionModel) : null;
            default:
                return null;
        }
    }

    private renderAction(action: SimpleTimetableActionModel) {
        if (!action || !action.actionType) {
            return;
        }

        return (<>
            <div className="top">
                {this.renderActionType(action.actionType)}
                <span className="time">{DateUtils.getTimeFromString(action.plannedStartTime)} - {DateUtils.getTimeFromString(action.plannedEndTime)}</span>
            </div>
            <div className="bottom">
                <Button
                    className="details"
                    variant="text"
                    text={i18n.t("timetable.actions.detailsAction.button")}
                    type="secondary"
                    onClick={this.onClickDetailsButton.bind(this)}
                    testId="details-btn"
                />
                {this.renderDetailsPopup(action.id)}
                {this.props.canUpdate && this.renderModifyButton(action)}
            </div>
        </>);
    }

    private renderModifyButton(action: SimpleTimetableActionModel) {
        const timetableStore = this.context.timetableStore as ITimetableStore;

        if (action.canceled) {
            return (
                <Button
                    text={i18n.t("timetable.actions.modifyAction.button")}
                    className="modify disabled"
                    type="secondary"
                    disabled
                    testId={`modify-${action.id}`}
                    variant="text"
                />
            );
        } else {
            return (
                <NavLink
                    to={`${routingAddresses.timetable.modifyAction}/${action.id}`}
                    className="modify"
                    data-testid={`modify-${action.id}`}
                    onClick={() => {
                        timetableStore.setEditElement(this.props.testId);
                    }}
                >
                    {i18n.t("timetable.actions.modifyAction.button")}
                </NavLink>
            );
        }
    }

    private renderActionType(actionType: TimetableActionTypes) {
        return (
            <div className="action-type">
                {TimetableActionTypesFirstLetter[actionType]}
            </div>
        );
    }

    private renderName(name: string) {
        return <p>{name}</p>;
    }

    private renderDetailsPopup(id: string) {

        return this.state.openDetailsPopup && (
            <DetailsPopup
                timetableElemId={id}
                openDetailsPopup={this.state.openDetailsPopup}
                onCancel={() => this.setState({openDetailsPopup: false})}
            />
        );
    }

    private onClickDetailsButton() {
        this.setState({openDetailsPopup: true});
    }
}
